export const MODAL_HEADINGS = {
  0: 'Select Bidding',
  1: 'Bidding Details',
  2: 'Required Details',
  3: 'Invitation Sent',
};
